var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-snapshot"},[_c('div',{staticClass:"snapshot-container"},[_c('img',{staticClass:"snapshot-img",class:{
      'no-snapshot': !_vm.snapshot
    },attrs:{"src":_vm.snapshot ? _vm.snapshot : _vm.placeHolderImg}}),_vm._v(" "),_c('div',{staticClass:"snapshot-container-inner-wrapper",class:{
      'dark': _vm.isOldSnapshot
    }},[_vm._v("\n      "+_vm._s(_vm.isOldSnapshot ? 'Loading...' : '')+"\n      "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5827d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompSnapshot.vue
// module id = 279
// module chunks = 1